export default __webpack_public_path__ + "static/media/appExample.6d041e4b.png";